<template>
  <div>
    <el-upload
      :accept="accept"
      :action="CONFIG.ACTION_URL"
      :file-list="uploadFileList"
      :data="uploadParmas"
      :auto-upload="false"
      :show-file-list="true"
      :limit="limit"
      :on-change="onVideoUploadChange"
      ref="uploadFiles"
      :on-preview="handlePreview"
      :on-remove="handleRemove"
      :disabled="disabled"
      :before-upload="beforeUpload"
      :class="{
        'hide-upload-button': !isShow,
      }"
    >
      <el-button
        size="medium"
        type="primary"
        icon="el-icon-upload"
        v-if="isShow"
        >点击上传</el-button
      >
      <div slot="tip" class="el-upload__tip light-gray-color" v-if="isShow">
        支持{{ accept }}，单个文件大小不超过200MB
      </div>
    </el-upload>
    <!-- 展示文件列表 -->
    <template v-if="computedCompressingFileList.length > 0">
      以下文件正在执行压缩，请等待：
      <div
        v-for="(file, index) in computedCompressingFileList"
        :key="index"
        @click="handlePreview(file)"
        class="video-file-item"
      >
        <p>
          {{ file.name }}
          - 压缩进度:
          {{ compressionProgressMap[file.raw.uid] || 0 }}%
        </p>
      </div>
    </template>
  </div>
</template>

<script>
import * as CONFIG from "@/config";
import * as fileUtil from "@/common/file";
import Ffmpeg from "@/common/ffmpeg";

export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    accept: {
      type: String,
      default: ".mp4, .avi, .mov, .wmv, .flv, .mkv",
    },
    isShow: {
      type: Boolean,
      default: true,
    },
    limit: {
      type: Number,
      default: 10,
    },
  },
  data() {
    return {
      CONFIG: Object.freeze(CONFIG),
      uploadParmas: {
        // 授权码，不能改！！！！！
        token: CONFIG.UPLOAD_TOKEN,
        key: "",
      },
      uploadFileList: [],
      // 视频压缩进度Map
      compressionProgressMap: {},
      // { name:名称, url:路径 }
    };
  },
  computed: {
    // 正在压缩的fileList
    computedCompressingFileList() {
      return this.uploadFileList.filter((file) => {
        return (
          file.raw &&
          this.compressionProgressMap[file.raw.uid] &&
          this.compressionProgressMap[file.raw.uid] < 100
        );
      });
    },
  },
  methods: {
    beforeUpload(file) {
      if (this.compressionProgressMap[file.uid]) {
        this.$message.error("该文件已存在，请勿重复上传");
        this.$refs.uploadFiles.abort(file);
        return false;
      }
      const _this = this;
      const ffmpegInstance = new Ffmpeg(file, {
        onProgress({ ratio }) {
          // 计算压缩进度
          const progress = ratio > 0 ? (ratio * 100).toFixed(2) : 0;
          console.log("压缩进度：", progress);
          _this.$set(_this.compressionProgressMap, file.uid, progress);
        },
        compressRatio: 0.6, // 压缩比例
      });
      console.log("file:", file, ffmpegInstance);
      // 执行压缩
      return ffmpegInstance
        .compress()
        .then((res) => {
          return new Promise((resolve) => {
            console.log("compress res:", file, res);
            const reader = new FileReader();
            reader.readAsArrayBuffer(res);
            reader.onload = () => {
              this.uploadParmas.key = fileUtil.getUploadPath(
                res.name,
                reader.result
              );
              resolve(res);
            };
          });
        })
        .catch((err) => {
          console.log("压缩失败：", err);
          this.$message.error("视频压缩失败，请刷新页面重试");
          this.$alert(
            "视频压缩失败，请先暂存其他填写内容，再刷新页面重试",
            "温馨提示",
            {
              confirmButtonText: "确定",
            }
          );
        });
    },
    // 回显父组件传过来的文件
    initFileList(fileList) {
      this.uploadFileList = fileList || [];
    },
    //处理视频上传
    onVideoUploadChange(file, fileList) {
      console.log("onVideoUploadChange:", file, fileList);
      file.url = URL.createObjectURL(file.raw);
      this.uploadFileList = fileList;
      this.$refs.uploadFiles.submit();
    },

    // 上传文件预览事件
    handlePreview(file) {
      console.log("handlePreview:file-----", file);
      // 打开新窗口预览
      window.open(file.url);
    },
    // 上传文件删除按钮事件
    handleRemove(file, fileList) {
      this.uploadFileList = fileList;
    },
    // 重置
    reset() {
      this.$refs.uploadFiles.clearFiles();
      this.uploadFileList = [];
    },

    // 校验方法
    getData() {
      const hasUploadingFiles = this.uploadFileList.some(
        (item) => item.status === "uploading"
      );
      if (hasUploadingFiles) {
        this.$message.warning("请等待附件上传完毕");
        return false;
      }

      if (this.uploadFileList.length === 0) {
        this.$message.warning("请上传至少一个附件");
        return false;
      }
      return getUploadFileArr(this.uploadFileList);

      // 处理文件对象
      function getUploadFileArr(files) {
        return files.map((item) => {
          return {
            name: item.name,
            url: getItemUrl(item),
          };
        });
      }

      // 校验返回的url是否以http开头
      function getItemUrl(item) {
        if (item.url && item.url.startsWith("http")) {
          return item.url;
        } else {
          return fileUtil.getUploadedFileUrl(item.response.key);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.video-file-item {
  color: #f88545;
  cursor: pointer;
}
.hide-upload-button {
  ::v-deep .el-upload {
    display: none !important;
  }
}
</style>
